// Archetypes' question runs only in the first questions after signup
// (src/onboarding/FirstQuestions.jsx). On the wheel, Archetypes opens its
// sub-constellation straight away, as before.
export const ENTRY_QUESTIONS = [
  {
    key: "entry_archetype",
    spoke: "archetype",
    question: "When your people get together, which one are you?",
    options: [
      {
        id: "gatherer",
        label: "The one who gets everyone there",
        tags: [
          { key: "initiative", type: "offers" },
          { key: "gathering", type: "offers" },
          { key: "convener", type: "latent" },
        ],
      },
      {
        id: "confidant",
        label: "The one people tell things to",
        tags: [
          { key: "listening", type: "offers" },
          { key: "trustworthiness", type: "offers" },
          { key: "keeper", type: "latent" },
        ],
      },
      {
        id: "spark",
        label: "The one making everyone laugh",
        tags: [
          { key: "humor", type: "offers" },
          { key: "levity", type: "offers" },
          { key: "performer", type: "latent" },
        ],
      },
      {
        id: "seeker",
        label: "The one asking the big questions",
        tags: [
          { key: "curiosity", type: "offers" },
          { key: "depth", type: "offers" },
          { key: "intellectual_engagement", type: "needs" },
          { key: "philosopher", type: "latent" },
        ],
      },
      {
        id: "fixer",
        label: "The one who fixes what breaks",
        tags: [
          { key: "competence", type: "offers" },
          { key: "reliability", type: "offers" },
          { key: "caretaker", type: "latent" },
        ],
      },
      {
        id: "watcher",
        label: "The one off to the side, watching",
        tags: [
          { key: "observation", type: "offers" },
          { key: "space", type: "needs" },
          { key: "watcher", type: "latent" },
        ],
      },
    ],
  },
  {
    key: "entry_personality",
    spoke: "personality",
    question: "What do you want people to see first?",
    options: [
      {
        id: "warmth",
        label: "my warmth",
        tags: [
          { key: "warmth", type: "offers" },
          { key: "openness", type: "offers" },
          { key: "approachability", type: "offers" },
          { key: "connector", type: "latent" },
        ],
      },
      {
        id: "mind",
        label: "my mind",
        tags: [
          { key: "intellect", type: "offers" },
          { key: "depth", type: "offers" },
          { key: "intellectual_engagement", type: "needs" },
          { key: "thinker", type: "latent" },
        ],
      },
      {
        id: "style",
        label: "my style",
        tags: [
          { key: "aesthetic_sense", type: "offers" },
          { key: "distinctiveness", type: "offers" },
          { key: "aesthete", type: "latent" },
        ],
      },
      {
        id: "realness",
        label: "that I'm real",
        tags: [
          { key: "honesty", type: "offers" },
          { key: "directness", type: "offers" },
          { key: "authenticity", type: "needs" },
          { key: "anti_performance", type: "latent" },
        ],
      },
      {
        id: "edge",
        label: "my edge",
        tags: [
          { key: "edge", type: "offers" },
          { key: "intensity", type: "offers" },
          { key: "confronts", type: "latent" },
        ],
      },
      {
        id: "useful",
        label: "that I'm useful",
        tags: [
          { key: "competence", type: "offers" },
          { key: "reliability", type: "offers" },
          { key: "utility_first", type: "latent" },
        ],
      },
      {
        id: "fine",
        label: "that I'm fine",
        tags: [
          { key: "privacy", type: "needs" },
          { key: "space", type: "needs" },
          { key: "self_protective", type: "latent" },
          { key: "hidden_depths", type: "latent" },
        ],
      },
    ],
  },
  {
    key: "entry_values",
    spoke: "values",
    question: "Who do you owe something to?",
    options: [
      {
        id: "my_people",
        label: "my people and that's it",
        tags: [
          { key: "loyalty", type: "offers" },
          { key: "tribal_devotion", type: "offers" },
          { key: "closed_circle", type: "latent" },
        ],
      },
      {
        id: "those_who_helped",
        label: "everyone who's ever helped me",
        tags: [
          { key: "reciprocity", type: "offers" },
          { key: "gratitude", type: "offers" },
          { key: "debt_conscious", type: "latent" },
        ],
      },
      {
        id: "anyone",
        label: "anyone who needs it",
        tags: [
          { key: "generosity", type: "offers" },
          { key: "expansive_care", type: "offers" },
          { key: "meaningful_giving", type: "needs" },
          { key: "universal_circle", type: "latent" },
        ],
      },
      {
        id: "the_future",
        label: "the future",
        tags: [
          { key: "long_view", type: "offers" },
          { key: "generational_thinking", type: "offers" },
          { key: "principle_driven", type: "latent" },
        ],
      },
      {
        id: "myself_first",
        label: "myself, first",
        tags: [
          { key: "self_authorship", type: "offers" },
          { key: "own_oxygen", type: "needs" },
          { key: "refusal_of_obligation", type: "latent" },
        ],
      },
      {
        id: "no_one",
        label: "no one, we all chose this",
        tags: [
          { key: "agency", type: "offers" },
          { key: "libertarian_streak", type: "latent" },
          { key: "atomized_self", type: "latent" },
        ],
      },
    ],
  },
  {
    key: "entry_behavior",
    spoke: "behavior",
    question: "What do you do when nobody needs anything from you?",
    options: [
      {
        id: "ahead_on_work",
        label: "get ahead on work",
        tags: [
          { key: "drive", type: "offers" },
          { key: "work_ethic", type: "offers" },
          { key: "identity_in_output", type: "latent" },
          { key: "struggles_to_stop", type: "latent" },
        ],
      },
      {
        id: "reach_out",
        label: "reach out to someone",
        tags: [
          { key: "relational_warmth", type: "offers" },
          { key: "connection", type: "needs" },
          { key: "socially_replenished", type: "latent" },
        ],
      },
      {
        id: "rest",
        label: "rest",
        tags: [
          { key: "knows_their_limits", type: "offers" },
          { key: "healthy_pacing", type: "latent" },
        ],
      },
      {
        id: "make",
        label: "make something",
        tags: [
          { key: "creative_drive", type: "offers" },
          { key: "making_time", type: "needs" },
          { key: "maker_at_core", type: "latent" },
        ],
      },
      {
        id: "phone",
        label: "lose an hour on my phone",
        tags: [
          { key: "distractible", type: "latent" },
          { key: "possibly_burnt_out", type: "latent" },
        ],
      },
      {
        id: "outside",
        label: "go outside",
        tags: [
          { key: "groundedness", type: "offers" },
          { key: "nature_or_motion", type: "needs" },
          { key: "body_led", type: "latent" },
        ],
      },
      {
        id: "panic",
        label: "panic a little",
        tags: [
          { key: "identity_threaded_to_demand", type: "latent" },
          { key: "unfamiliar_with_stillness", type: "latent" },
        ],
      },
    ],
  },
  {
    key: "entry_belief",
    spoke: "belief",
    question: "Above all, what do you believe in?",
    options: [
      {
        id: "god",
        label: "God",
        tags: [
          { key: "faith", type: "offers" },
          { key: "transcendent_anchor", type: "latent" },
        ],
      },
      {
        id: "nature",
        label: "Nature",
        tags: [
          { key: "reverence_for_nature", type: "offers" },
          { key: "ecological_self", type: "latent" },
          { key: "pantheistic_leanings", type: "latent" },
        ],
      },
      {
        id: "love",
        label: "Love",
        tags: [
          { key: "love_as_compass", type: "offers" },
          { key: "relational_metaphysics", type: "latent" },
        ],
      },
      {
        id: "myself",
        label: "Myself",
        tags: [
          { key: "self_trust", type: "offers" },
          { key: "self_authored", type: "latent" },
        ],
      },
      {
        id: "others",
        label: "Other people",
        tags: [
          { key: "faith_in_community", type: "offers" },
          { key: "humanist", type: "latent" },
        ],
      },
      {
        id: "reason",
        label: "Reason",
        tags: [
          { key: "rationality", type: "offers" },
          { key: "evidence_anchored", type: "latent" },
          { key: "secular", type: "latent" },
        ],
      },
      {
        id: "unnamed",
        label: "Something I can't name",
        tags: [
          { key: "open_seeking", type: "offers" },
          { key: "spiritual_but_undefined", type: "latent" },
        ],
      },
      {
        id: "nothing",
        label: "Nothing, really",
        tags: [
          { key: "clear_eyed", type: "offers" },
          { key: "nihilist_or_secular", type: "latent" },
        ],
      },
      {
        id: "working",
        label: "Whatever's working that day",
        tags: [
          { key: "pragmatist", type: "offers" },
          { key: "anti_dogma", type: "latent" },
        ],
      },
    ],
  },
];

export const ENTRY_TEASER_KEYS = ENTRY_QUESTIONS.map((q) => q.key);

// Spoke accent colors — matches MODULES in PersonalWeb. Duplicated here so the
// EntryTeaser can theme itself without importing from the home-web component.
export const SPOKE_ACCENTS = {
  archetype: "#8B7BC2",
  personality: "#C2A057",
  values: "#5E8A6A",
  behavior: "#D4773B",
  belief: "#C27087",
};

// The part names the wheel shows, for the teaser's header.
export const SPOKE_LABELS = {
  archetype: "Archetypes",
  personality: "Personality",
  values: "Values",
  behavior: "Behavior",
  belief: "Belief",
};

export const ENTRY_BY_SPOKE = ENTRY_QUESTIONS.reduce((acc, q) => {
  acc[q.spoke] = q;
  return acc;
}, {});
